module.exports = __webpack_public_path__ + "img/LOGO-500.b7d03ecb.png";